module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joel B. Altman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Joel B. Altman")]), _vm._v(" is professor emeritus of English at the University of California, Berkeley, and the author of "), _c('I', [_vm._v("The Tudor Play of Mind: Rhetorical Inquiry and the Development of Elizabethan Drama.")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11fWZ8p/tc-custom/9780226016122.jpg?1722576312326",
      "alt": "This image is the cover for the book Improbability of Othello"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Improbability of Othello\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Shakespeare’s dramatis personae exist in a world of supposition, struggling to connect knowledge that cannot be had, judgments that must be made, and actions that need to be taken.  For them, probability—what they and others might be persuaded to believe—governs human affairs, not certainty. Yet negotiating the space of probability is fraught with difficulty. Here, Joel B. Altman explores the problematics of probability and the psychology of persuasion in Renaissance rhetoric and Shakespeare’s theater.")]), _c('p', [_vm._v("Focusing on the "), _c('i', [_vm._v("Tragedy of Othello,")]), _vm._v(" Altman investigates Shakespeare’s representation of the self as a specific realization of tensions pervading the rhetorical culture in which he was educated and practiced his craft. In Altman’s account, Shakespeare also restrains and energizes his audiences’ probabilizing capacities, alternately playing the skeptical critic and dramaturgic trickster. A monumental work of scholarship by one of America’s most respected scholars of Renaissance literature, "), _c('i', [_vm._v("The Improbability of Othello")]), _vm._v(" contributes fresh ideas to our understanding of Shakespeare’s conception of the self, his shaping of audience response, and the relationship of actors to his texts.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0